import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	Output,
	SimpleChanges
} from '@angular/core';
import { StorageKey } from 'src/models/general/storage.key.enum';

interface ColumnSettings {
	name: string;
	enabled: boolean;
}

@Component({
    selector: 'pim-table-column-selector',
    templateUrl: './table-column-selector.component.html',
    styleUrls: ['./table-column-selector.component.sass'],
    standalone: false
})
export class TableColumnSelectorComponent implements OnChanges {
	@Input()
	available!: string[] | null;

	@Input()
	storageKey!: StorageKey;

	@Output()
	columnsChanged: EventEmitter<string[]> = new EventEmitter<string[]>();

	columnSettings: ColumnSettings[] = [];

	showColumnSelection: boolean = false;

	constructor(private elementRef: ElementRef) {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.available && this.available) {
			this.mapProvidedColumnsToInternalSettings();
			this.initSelectedColumns();
			this.updateStorageAndPublishChanges();
		}
	}

	updateColumnSettings(colName: ColumnSettings): void {
		this.toggleColumnSettings(colName);
		this.updateStorageAndPublishChanges();
	}

	// TODO: Sollte in nen globalen Listener umgewandelt werden
	// https://stackoverflow.com/a/59234391
	@HostListener('document:click', ['$event'])
	clickout(event: any): void {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.showColumnSelection = false;
		}
	}

	private initSelectedColumns(): void {
		const savedColumns = localStorage.getItem(this.storageKey);
		if (savedColumns) {
			const selectedColumnNames = JSON.parse(savedColumns);
			this.columnSettings.forEach((entry: ColumnSettings) => {
				if (selectedColumnNames.indexOf(entry.name) === -1) {
					entry.enabled = false;
				}
			});
		}
	}

	// TODO: Auf SessionDb umstellen (muss man noch reinziehen)
	private updateStorageAndPublishChanges(): void {
		const colNames = this.getSelectedColumnNames();
		localStorage.setItem(this.storageKey, JSON.stringify(colNames));
		this.columnsChanged.emit(colNames);
	}

	private toggleColumnSettings(colName: ColumnSettings): void {
		colName.enabled = !colName.enabled;
	}

	private mapProvidedColumnsToInternalSettings(): void {
		if (!this.available) {
			return;
		}
		this.columnSettings = this.available.map((entry: string) => {
			return {
				name: entry,
				enabled: true,
			};
		});
	}

	private getSelectedColumnNames(): string[] {
		return this.columnSettings.reduce((list: string[], entry: ColumnSettings) => {
			if (entry.enabled) {
				list.push(entry.name);
			}
			return list;
		}, []);
	}
}
